import { createContext, type ReactNode, useContext } from 'react';

interface SearchContextType {
  searchString: string;
  /**
   * Optional search string for cells that should only highlight when the
   * primary search has reached a higher minimum length (e.g. fields that
   * the API only matches at 3+ characters). When omitted, falls back to
   * `searchString`.
   */
  multiFieldSearchString?: string;
}

/**
 * Context to provide the search string to all components that need it.
 * This allows us to avoid prop drilling and keep the search string in
 * a single source of truth.
 */
export const SearchContext = createContext<SearchContextType>({
  searchString: '',
});

export const useSearchContext = () => {
  return useContext(SearchContext);
};

interface SearchProviderProps {
  children: ReactNode;
  searchString: string;
  multiFieldSearchString?: string;
}

export const SearchProvider = ({
  children,
  searchString,
  multiFieldSearchString,
}: SearchProviderProps) => {
  return (
    <SearchContext.Provider value={{ searchString, multiFieldSearchString }}>
      {children}
    </SearchContext.Provider>
  );
};
